import React, { PropTypes } from 'react'

import Field from 'components/grid-form-field'

const GridFormFieldCount = (props) => (
  <Field
    {...props}
    optional={
      props.field && (props.field.value || props.field.active)
        ? `${props.field.value.length} / ${props.maxChars}`
        : props.optional
    }
  />
)

GridFormFieldCount.propTypes = {
  border: PropTypes.bool,
  children: PropTypes.any,
  field: PropTypes.object,
  label: PropTypes.string,
  optional: PropTypes.string,
  maxChars: PropTypes.number,
}

export default GridFormFieldCount



/** WEBPACK FOOTER **
 ** ./src/components/grid-form-field-count/grid-form-field-count.js
 **/